// API and processing errors shown by the shared error presenter.
export default {
  "文档正文至少需要 8 个字符。": "Document content must contain at least 8 characters.",
  "文档标题不能超过 64 个字符": "Document title must not exceed 64 characters",
  "文档类型不能超过 64 个字符": "Document type must not exceed 64 characters",
  "文件扩展名与二进制内容不一致，请确认文件未损坏后重新上传。": "The file extension does not match its contents. Check that the file is intact and upload it again.",
  "用户不存在": "User not found",
  "账号或密码错误": "Invalid account or password",
  "该手机号已注册": "Phone number already registered",
  "手机号已注册": "Phone number already registered",
  "验证码错误或已过期": "Invalid or expired verification code",
  "验证码无效或已过期": "Invalid or expired verification code",
  "短信发送失败，请稍后重试": "Failed to send SMS, please try again later",
  "登录已过期，请重新登录": "Session expired, please log in again",
  "无效的登录凭证": "Invalid credentials",
  "权限不足": "Permission denied",
  "设备不存在": "Device not found",
  "设备已被绑定": "Device already bound",
  "设备绑定失败": "Failed to bind device",
  "设备解绑失败": "Failed to unbind device",
  "资源不存在": "Resource not found",
  "请求参数错误": "Invalid request parameters",
  "服务器内部错误，请稍后重试": "Internal server error, please try again later",
  "文件上传失败": "File upload failed",
  "手机号格式不正确": "Invalid phone number format",
  "请输入正确的手机号": "Please enter a valid phone number",
  "用户名已存在": "Username already exists",
  "账号不可用": "Account unavailable",
  "该手机号尚未设置密码，请使用验证码登录后到我的-账户安全设置密码": "This phone number has no password yet. Please log in with a verification code and set a password in Profile > Account Security.",
  "验证码发送过于频繁，请一分钟后重试": "Verification codes are being requested too frequently. Please try again in one minute.",
  "短信服务未配置": "SMS service is not configured",
  "请输入旧密码": "Please enter your old password",
  "旧密码错误": "Old password is incorrect",
  "头像仅支持 JPG、PNG 或 WebP 图片": "Avatar only supports JPG, PNG, or WebP images",
  "请选择头像图片": "Please choose an avatar image",
  "头像不能超过5MB": "Avatar must be 5MB or smaller",
  "聊天记录不存在或无权访问": "Chat history does not exist or you do not have access",
  "设备业务编号不支持": "Device business number is not supported",
  "设备标识与已有设备冲突": "Device identifier conflicts with an existing device",
  "设备已绑定到您的账号": "Device is already bound to your account",
  "设备已被其他用户绑定": "Device is already bound to another user",
  "设备绑定冲突，请刷新后重试": "Device binding conflict. Please refresh and try again",
  "设备尚未绑定，请先扫码绑定": "Device is not bound yet. Please scan the code to bind it first",
  "设备不属于当前用户": "Device does not belong to the current user",
  "请填写必填项后重试": "Complete the required fields and try again.",
  "网络连接失败，请检查网络后重试": "Network connection failed. Check your connection and try again.",
  "请求超时，请稍后重试": "The request timed out. Try again later.",
  "请求过于频繁，请稍后重试": "Too many requests. Try again later.",
  "服务暂不可用，请稍后重试": "The service is temporarily unavailable. Try again later.",
  "文件过大，请缩小文件后重试。": "The file is too large. Use a smaller file and try again.",
  "不支持该文件格式，请选择支持的格式后重试。": "This file format is not supported. Choose a supported format and try again.",
  "PDF 正文提取失败，请确认文件可正常打开且未加密，或另存为 PDF 后重试。": "Could not extract text from the PDF. Check that it opens correctly and is not encrypted, or save it as a new PDF and try again.",
  "文档处理失败，请稍后重试；如持续失败，请联系管理员。": "Document processing failed. Try again later; if it persists, contact an administrator.",
  "文档处理失败，请稍后重试": "Document processing failed. Try again later.",
  "文档清洗任务执行失败": "Document cleaning failed. Try again later; if it persists, contact an administrator.",
  "Dify 文档清洗失败，请稍后重试": "Document cleaning failed. Try again later.",
  "平台知识服务未配置": "The knowledge service is not configured. Contact an administrator.",
  "平台知识服务请求失败": "The knowledge service request failed. Try again later.",
  "平台知识服务不可用": "The knowledge service is unavailable. Try again later.",
  "知识库不存在": "The knowledge base does not exist.",
  "文档处理任务不存在": "The document processing task does not exist.",
  "请选择要上传的文件": "Choose a file to upload.",
  "重新索引需要上传修订后的文件": "Upload a revised file to rebuild the index.",
  "文档清洗功能未启用": "Document cleaning is not enabled. Contact an administrator.",
  "文档清洗配置不完整": "Document cleaning configuration is incomplete. Contact an administrator.",
  "Dify 返回了不可信的清洗文件地址": "The processing service returned an invalid file address. Contact an administrator.",
  "Dify 文件上传未返回文件 ID": "The processing service did not return a file ID. Try again later.",
  "清洗任务未返回处理后的文档": "The processing task did not return a cleaned document. Try again later.",
  "清洗结果缺少下载地址": "The cleaned document has no download address. Try again later.",
  "文档清洗任务未成功完成": "Document cleaning did not complete successfully. Try again later.",
  "Dify 未返回任务完成事件": "The processing service did not confirm completion. Try again later.",
  "认证凭证无效": "Your session is invalid. Sign in again.",
  "短信发送失败": "Failed to send SMS. Try again later.",
  "检测到该文件扩展名为 .xls，但实际不是标准 Excel 文件。请使用聊天记录的新版 .xlsx 导出文件，或在 Excel 中另存为 .xlsx 后再上传。": "The file has an .xls extension but is not a valid Excel file. Use the new .xlsx chat export, or save it as .xlsx in Excel before uploading."
};
